module.exports = __webpack_public_path__ + "assets/img/gift-1-f7a87df5.png";